export interface IProduct {
	_id: string;
	code: string;
	internalLabel: string;
	marketingLabel: string;
	createdAt: string;
	updatedAt: string;
	createdBy: string;
	updatedBy: string;
}

export enum ProductMarket {
	IT_IT = "IT_IT",
	BG_BG = "BG_BG",
	DE_AT_Olymp = "DE_AT_Olymp",
	EN_CN = "EN_CN",
	EN_KR = "EN_KR",
	EN_MX = "EN_MX",
	EN_UK = "EN_UK",
	EN_US = "EN_US",
	EN_US_Aerco = "EN_US_Aerco",
	EN_US_RBI = "EN_US_RBI",
	ES_ES = "ES_ES",
	FR_FR = "FR_FR",
	FR_US = "FR_US",
	FR_US_Aerco = "FR_US_Aerco",
	FR_US_RBI = "FR_US_RBI",
	FR_TN = "FR_TN",
	GR_GR = "GR_GR",
	HU_HU = "HU_HU",
	PL_PL = "PL_PL",
	PT_PT = "PT_PT",
	RO_RO = "RO_RO",
	RU_RU = "RU_RU",
	EN_UK_Gemtex = "EN_UK_Gemtex",
	EN_UK_Adveco = "EN_UK_Adveco",
	EN_NL_Lochinvar = "EN_NL_Lochinvar",
	NL_NL_Aosmith = "NL_NL_Aosmith",
	FR_FR_Engie = "FR_FR_Engie",
	DE_DE = "DE_DE",
	CZ_CZ = "CZ_CZ",
}

export interface IProductCrm {
	seriale: string | null,
	prodotto: string | null,
	modello: string | null,
	codice_articolo: string | null,
	data_fine_costruzione: Date | null,
	immagine: string,
	manuali: string[],
	markets: ProductMarket[],
	certificato_garanzia: boolean,
}
